var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('transition',{attrs:{"name":"van-slide-right"}},[_c('keep-alive',[_c('router-view',{staticClass:"view-child"})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }